import { createAttachmentsApi } from '#/api/platform/attachments';

export const purchaseOrderAttachmentsApi = createAttachmentsApi(
  (businessId) => `/srm/purchase-order/${businessId}/attachments`,
);
